import { createClient } from '@supabase/supabase-js';

// Public client config. Both values are safe to ship in the bundle:
// the anon/publishable key is the public client key, protected by Supabase
// row-level security. Real secrets never live here.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // Surface a clear error early rather than failing deep inside an auth call.
  throw new Error(
    'Missing Supabase env vars. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Rely on Supabase's built-in session persistence (localStorage) so the
    // user stays logged in across refreshes, and auto-refresh of the token.
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
